// Setup › Break-glass at `/c/{slug}/setup/break-glass` (M5-05; core, managers): every agency
// break-glass session on the company, with the owner's decisions (features/agency).
import { createRoute } from "@tanstack/react-router";
import { CompanyBreakGlassPage } from "../features/agency/company-break-glass";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupBreakGlassRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "break-glass",
  component: function SetupBreakGlass() {
    const { api } = setupBreakGlassRoute.useRouteContext();
    return <CompanyBreakGlassPage api={api} company={useCompany()} />;
  },
});
